import { useTranslation } from "react-i18next";
import { IPrv } from "interface";
import { checkBoxChange, modalControl, successControl } from "util/commAction";
import { RefObject, useEffect, useState } from "react";
import i18n from "locales/i18n";
import Button from "components/button/default";
import { useJoinContext } from "components/context/joinContext";
import TermModal from "./termModal";
import { useMutation } from "@tanstack/react-query";
import { termDetailApi } from "components/api/comm";
import { useNavigate } from "react-router-dom";
import "./term.scss";

type IProps = {
  prvList: IPrv[] | null;
  checkRef: RefObject<HTMLDivElement | null>;
};

type Prvs = {
  langCd: string;
  prvGrpCd: string;
  prvSeq: string;
  required: boolean;
  prvAgYn: string;
};

export default function Term({ prvList, checkRef }: IProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { onJoinInf } = useJoinContext();
  const langCd = i18n.language;
  const [checkList, setCheckList] = useState<Prvs[]>([]);
  const [authAgr, setAuthAgr] = useState<any[]>([
    {
      authSubCd: "MKT001",
      agrYn: "N",
    },
  ]);

  const handleChange = (id: string, checked: boolean) => {
    if (id === "A") {
      //전체 체크
      setCheckList(
        checkList.map((prv) => {
          return {
            ...prv,
            prvAgYn: checked ? "Y" : "N",
          };
        })
      );
    }
    if (id !== "A") {
      setCheckList(
        checkList.map((prv) => {
          return prv.prvGrpCd === id
            ? {
                ...prv,
                prvAgYn: checked ? "Y" : "N",
              }
            : prv;
        })
      );
    }
  };

  const isAble = checkList.every((_prv) =>
    _prv.required ? _prv.prvAgYn === "Y" : true
  );

  //약관 상세
  // //약관 상세
  const termDetailMutation = useMutation({
    mutationFn: termDetailApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            const { prvNm, prvCd, trmCn } = res.data.prvDtl;
            modalControl({
              isOpen: true,
              ttl: prvNm,
              styles:
                "h-auto overflow-hidden max-w-[90%] py-4 px-5 md:px-10 pt-8 max-w-[700px]",
              chckBtn: false,
              inner: <TermModal prvCd={prvCd} prvNm={prvNm} />,
            });
          },
        });
      }
    },
  });
  const handleTermDetail = (prvCd: string) => {
    termDetailMutation.mutate(prvCd);
  };

  const handleNext = () => {
    onJoinInf({
      checkList,
      authAgr,
    });
    navigate("/join/mail");

    // setJoinInf({
    //   checkList,
    //   authAgr,
    // });

    // setJoinStep(2);

    // localStorage.setItem("joinStep", 2 + "");

    // localStorage.setItem(
    //   "joinInf",
    //   JSON.stringify({
    //     prvList: checkList,
    //     authAgr,
    //   })
    // );
  };

  useEffect(() => {
    if (prvList) {
      setCheckList(
        prvList.map((_prv: any, index: number) => {
          return {
            langCd: langCd,
            prvGrpCd: _prv.prvCd,
            prvSeq: index + 1 + "",
            required: _prv.essYn === "Y",
            prvAgYn: "N",
          };
        })
      );
    }
  }, [prvList]);

  return (
    <>
      <div className="term" ref={checkRef}>
        <div>
          <div className="chk-all">
            <label className="checkbox big">
              <input
                type="checkbox"
                name="all"
                id="all"
                onChange={(e) => {
                  const checked = e.currentTarget.checked;
                  const parent = checkRef.current
                    ?.children[0] as HTMLDivElement;
                  checkBoxChange({
                    checked,
                    parent,
                    type: "all",
                  });
                  handleChange("A", checked);
                }}
              />

              {t("chck_all_sng")}
            </label>
          </div>
          <ul className="pb-6">
            {prvList &&
              prvList.map((prv, index) => {
                return (
                  <li key={prv.prvCd} className="between-center py-2">
                    <div className={""}>
                      <label className="checkbox border-0">
                        <input
                          type="checkbox"
                          name={"prvCd"}
                          id={prv.prvCd}
                          data-essyn={prv.essYn}
                          data-prv={prv}
                          onChange={(e) => {
                            const checked = e.currentTarget.checked;
                            const parent = checkRef.current
                              ?.children[0] as HTMLDivElement;

                            checkBoxChange({
                              checked,
                              parent,
                              type: "item",
                              essYn: prv.essYn === "Y",
                            });

                            handleChange(prv.prvCd, checked);
                          }}
                        />
                        {prv.essYn === "Y"
                          ? t("bck_ttl_chckbx_required")
                          : t("bck_ttl_chckbx_optional")}
                        {prv.prvNm}
                      </label>
                    </div>
                    <div className="">
                      <button onClick={() => handleTermDetail(prv.prvCd)} />
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
        <div className="consent">
          <label className="checkbox">
            <input
              type="checkbox"
              id="agrYn"
              name="agrYn"
              data-authsubcd="MKT001"
              onChange={(e) => {
                const checked = e.currentTarget.checked;
                const value = {
                  authSubCd: "MKT001",
                  agrYn: checked ? "Y" : "N",
                };
                setAuthAgr([value]);
              }}
            />
            {t("chckbx_lbl_htl_sng")}{" "}
            <span className="text-blue-300">{t("txt_agr_sng_step_1")}</span>
          </label>
          <p>{t("chckbx_dscrp_sng")}</p>
        </div>
      </div>
      <Button
        text={t("btn_agr_sng")}
        styels="join-next mt-10"
        onClick={handleNext}
        disabled={!isAble}
      />
    </>
  );
}
